exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes preloader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes preloader-spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.result{padding:.75rem;text-align:center;height:100%;position:relative}.result .brand-icon{font-size:5.5rem;color:#04be02;line-height:1;margin:1rem 0 .5rem}.result .result-error .brand-icon,.result .result-forbidden .brand-icon{color:#f6383a}.result h1{font-size:1rem;font-weight:400;margin:0 0 .5rem}.result .text{margin:.2rem 0 0;color:#999;font-size:.75rem}.result .buttons{margin-top:1.5rem}.result .buttons .button+.button{margin-top:.75rem}.result .bottom{position:absolute;bottom:1rem;left:0;width:100%;font-size:.7rem;color:#61749b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cdbc949","scoped":false,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/result/index.vue
// module id = mJ01
// module chunks = 1